

import React, { useContext } from 'react';
// room context
import { RoomContext } from '../context/RoomContext';
// headless ui menu
import { Menu } from '@headlessui/react';
// icons
import { BsChevronDown } from 'react-icons/bs';

const lis = [
  { name: '0 Kids', value: 0 },
  { name: '1 Kid', value: 1 },
  { name: '2 Kids', value: 2 },
];

const KidsDropdown = () => {
  const { kids, setKids } = useContext(RoomContext);
  return (
    <Menu as='div' className='w-full h-full bg-white relative'>
      {/* btn */}
      <Menu.Button id="kids" className='w-full h-full flex items-center justify-between px-2 lg:px-8'>
        {kids === 0 ? 'No kids' : (kids === 1 ? '1 Kid' : kids + ' Kids')}
        <BsChevronDown className='text-base text-accent-hover' />
      </Menu.Button>
      {/* items */}
      <Menu.Items
        as='ul'
        className='bg-white absolute w-full flex flex-col z-40'
      >
        {lis.map((li, index) => {
          return (
            <Menu.Item
              onClick={() => setKids(li.value)}
              as='li'
              className='border-b last-of-type:border-b-0 h-12 hover:bg-accent hover:text-white w-full flex justify-center items-center cursor-pointer'
              key={index}
            >
              {li.name}
            </Menu.Item>
          );
        })}
      </Menu.Items>
    </Menu>
  );
};

export default KidsDropdown;
